import BaseInputComponent from '@/slango-multiverse/components/inputs/BaseInputComponent.vue';
export default {
  extends: BaseInputComponent,
  props: {
    onSchedule: Function
  },
  data: function () {
    return {
      loading: false,
      showIntervalSelector: false,
      intervalTime: {
        hours: this.$st('utils.hour', 2),
        days: this.$st('utils.day', 2),
        months: this.$st('utils.month', 2)
      }
    };
  },
  watch: {
    value: {
      handler() {
        if (!this.value) return;
        let normalizedDate = new Date(this.value.date);
        normalizedDate.setHours(this.value.hour);
        normalizedDate.setMinutes(this.value.minute);
        const dateISOString = normalizedDate.toISOString();
        if (this.value.dateISOString !== dateISOString) {
          Object.assign(this.value, {
            scheduledDate: normalizedDate,
            dateISOString
          });
        }
      },
      deep: true
    }
  },
  created() {
    this.value = {
      every: 1,
      interval: 'days',
      hour: 0,
      minute: 0
    }, this.value.date = new Date().setHours(0, 0, 0, 0);
    this.value.hour = new Date().getHours();
  },
  methods: {}
};